import { useMemo } from 'react';
import type { Bookmark } from '@/lib/bookmark/types';
import type { ModelName } from '@pigello/pigello-matrix';
import { parseBookmarkQueryParams } from '@/components/workflows/utils';
import { useGetList } from '@/requests/hooks';
import { useCustomCountByPath } from './use-custom-count-by-path';

export function useBookmarkCount(bookmark: Bookmark) {
  const { modelName, filters, overrideUrl, overrideUrlReplaceAll, search } =
    useMemo(() => parseBookmarkQueryParams(bookmark), [bookmark]);

  const countQuery = useCustomCountByPath(bookmark.path);

  const {
    data: countList,
    isLoading,
    isPending,
  } = useGetList({
    modelName: modelName as ModelName,
    overrideUrl,
    overrideUrlReplaceAll,
    queryParams: {
      filters: filters ?? {},
      search,
      page: 1,
      pageSize: 1,
      enableGlobalFilters: true,
    },
    enabled: !!modelName && !countQuery,
  });

  const count = countQuery?.data?.count ?? countList?.meta?.total_amount ?? '-';

  return {
    count,
    isLoading: countQuery ? countQuery.isLoading : isLoading || isPending,
  };
}
